import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
  setCanopy,
  setScreens,
  setSpeakerOption
} from '../../../redux/reducers/models'
import { setLoading } from '../../../redux/reducers/loader'
import PropTypes from 'prop-types'

const Questions = ({ options, questionType }) => {
  const dispatch = useDispatch()
  const { screens, questions, canopy, speakerOption } = useSelector(
    ({ models }) => models
  )

  const questionActions = {
    QuestionOne: (value) => {
      dispatch(setSpeakerOption(+value))
    },

    QuestionTwo: (value) => {
      dispatch(setScreens(+value))
      dispatch(setCanopy(false))
    },
    QuestionThree: (value) => {
      const result = value === 'Yes'
      dispatch(setCanopy(result))

      if (result) {
        dispatch(setScreens(screens + 3))
      } else if (screens > 3) {
        dispatch(setScreens(screens - 3))
      }
    }
  }

  const handleModelChange = (value) => {
    dispatch(setLoading(true))
    questionActions[questionType] && questionActions[questionType](value)
  }

  useEffect(() => {
    const inputs = document.querySelectorAll('input[type="radio"]')
    inputs.forEach((input) => {
      input.disabled = questionType === 'QuestionThree'
    })
  }, [questionType])

  const btnClasses = {
    1: (option) => speakerOption === option,
    2: (option) => screens === option,
    3: (option) => canopy === (option === 'Yes')
  }

  const handleBtnClasses = (option) => {
    return btnClasses[questions](option)
      ? 'ModelSelector__config__optionSelected'
      : 'ModelSelector__config__option'
  }

  const speakerOptions = {
    1: 'Speaker Post',
    2: 'Drive Thru',
    3: 'Speaker Post & Drive Thru'
  }

  const screenOptions = {
    1: 'One Screen',
    2: 'Two Screens',
    3: 'Three Screens'
  }

  const canopyOptions = {
    Yes: 'With canopy',
    No: 'Without canopy'
  }

  const speakerOptions2 = {
    1: 'Speaker post + one screen',
    2: 'Speaker post + 2 screens',
    3: 'Speaker post + 3 screens'
  }

  const getScreenOptions = () => {
    return speakerOption === 3 ? speakerOptions2 : screenOptions
  }

  const optionHandlers = {
    1: speakerOptions,
    2: getScreenOptions(),
    3: canopyOptions
  }

  return (
    <div className='ModelSelector__config'>
      {options.map((option) => (
        <button
          type='button'
          onClick={() => handleModelChange(option)}
          key={option}
          className={handleBtnClasses(option)}
        >
          {optionHandlers[questions] && optionHandlers[questions][option]}
        </button>
      ))}
    </div>
  )
}

Questions.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ).isRequired,
  questionType: PropTypes.oneOf([
    'QuestionOne',
    'QuestionTwo',
    'QuestionThree'
  ]).isRequired
}

export default Questions
